/**
 * @generated SignedSource<<ff97c6028392f9593f4d36392e1c8a2a>>
 * @relayHash f6940aa45b90c0fa8ec8cf731c1abafd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a41e2ffb051c9af7c2436fb73e7e977f47e35686950abc7620b6c57761511e6b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareHarmonisedTimelineEmbedQuery } from './JiraSoftwareHarmonisedTimelineEmbedQuery.graphql';

import isHierarchyBoardFilterEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraTimelineHierarchyBoardFilterRelayProvider';

const node: PreloadableConcreteRequest<JiraSoftwareHarmonisedTimelineEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a41e2ffb051c9af7c2436fb73e7e977f47e35686950abc7620b6c57761511e6b",
    "metadata": {},
    "name": "JiraSoftwareHarmonisedTimelineEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHierarchyBoardFilterRelayProvider": isHierarchyBoardFilterEnabled_provider
    }
  }
};

export default node;
